import { Component } from 'react';
import { Field } from 'redux-form';

import { isRavenswood } from 'common/helpers/featureFlags';

import { TextField /* SelectField */ } from '.';

class BirthDateFormFields extends Component {
  render() {
    const { countryCode = 'CA' } = this.props;
    if (isRavenswood()) {
      return (
        <div>
          <fieldset>
            <legend>Date of Birth</legend>
            <div className="c7-form__group">
              <Field
                name="birthMonth"
                labelClassName="c7-small"
                component={TextField}
                label="Month"
                placeholder="01"
                normalize={birthMonthNormalize}
                ref={(input) => {
                  this.birthMonth = input;
                }}
                refField="birthMonth"
                autocomplete="bday-month"
                withRef
                required
              />
              <Field
                name="birthDay"
                labelClassName="c7-small"
                component={TextField}
                label="Day"
                placeholder="01"
                normalize={birthDayNormalize}
                ref={(input) => {
                  this.birthDay = input;
                }}
                refField="birthDay"
                autocomplete="bday-day"
                withRef
                required
              />
              <Field
                name="birthYear"
                component={TextField}
                labelClassName="c7-small"
                label="Year"
                placeholder="1945"
                normalize={birthYearNormalize}
                ref={(input) => {
                  this.birthYear = input;
                }}
                refField="birthYear"
                autocomplete="bday-year"
                withRef
                required
              />
            </div>
          </fieldset>
        </div>
      );
    }
    return (
      <div>
        <span className="label">Date of Birth</span>
        <div className="c7-form__group">
          {countryCode === 'US' && (
            <>
              <Field
                name="birthMonth"
                labelClassName="c7-small"
                component={TextField}
                label="Month"
                placeholder="01"
                normalize={birthMonthNormalize}
                ref={(input) => {
                  this.birthMonth = input;
                }}
                refField="birthMonth"
                autocomplete="bday-month"
                withRef
                required
              />
              <Field
                name="birthDay"
                labelClassName="c7-small"
                component={TextField}
                label="Day"
                placeholder="01"
                normalize={birthDayNormalize}
                ref={(input) => {
                  this.birthDay = input;
                }}
                refField="birthDay"
                autocomplete="bday-day"
                withRef
                required
              />
            </>
          )}
          {countryCode !== 'US' && (
            <>
              <Field
                name="birthDay"
                labelClassName="c7-small"
                component={TextField}
                label="Day"
                placeholder="01"
                normalize={birthDayNormalize}
                ref={(input) => {
                  this.birthDay = input;
                }}
                refField="birthDay"
                autocomplete="bday-day"
                withRef
                required
              />
              <Field
                name="birthMonth"
                labelClassName="c7-small"
                component={TextField}
                label="Month"
                placeholder="01"
                normalize={birthMonthNormalize}
                ref={(input) => {
                  this.birthMonth = input;
                }}
                refField="birthMonth"
                autocomplete="bday-month"
                withRef
                required
              />
            </>
          )}
          <Field
            name="birthYear"
            component={TextField}
            labelClassName="c7-small"
            label="Year"
            placeholder="1945"
            normalize={birthYearNormalize}
            ref={(input) => {
              this.birthYear = input;
            }}
            refField="birthYear"
            autocomplete="bday-year"
            withRef
            required
          />
        </div>
      </div>
    );
  }
}

const birthMonthNormalize = (value) => {
  if (!value) {
    return value;
  }
  const birthDay = value.replace(/[^0-9]/g, '');
  return birthDay.slice(0, 2);
};

const birthDayNormalize = (value) => {
  if (!value) {
    return value;
  }
  const birthDay = value.replace(/[^0-9]/g, '');
  return birthDay.slice(0, 2);
};

const birthYearNormalize = (value) => {
  if (!value) {
    return value;
  }
  const birthDay = value.replace(/[^0-9]/g, '');
  return birthDay.slice(0, 4);
};

export default BirthDateFormFields;
